import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import AssetFormBody from "../../AssetFormBody";
import Asset from "../../../../../model/asset/Asset";
import AssetForm from "../AssetForm";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import PageHeaderView from "../../../../body/PageHeaderView";
import {Boxed} from "../../../../../hiberUiKit/src/molecules/Boxed/Boxed";
import PageContentView from "../../../../body/PageContentView";
import Attachment from "../../../../../model/attachment/Attachment";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {string} name new name.
	 */
	onSubmit: (asset: Asset) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Asset to edit.
	 */
	asset: Asset;
	/**
	 * On add file
	 */
	onAddOrUpdateFile: (file: (File | Attachment)[]) => void;
}

type IState = BaseFormViewState<AssetForm>;

export default class EditAssetFormView extends BaseFormView<AssetForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: AssetForm.createFromAsset(this.props.asset),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Edit asset"}/>
				<PageContentView>
					<AssetFormBody form={this.state.form}
								   onFieldChange={this.onFieldChanged}
								   onFieldCompleted={this.onFieldCompleted}
								   onFocusChange={this.onFocusChange}
								   onAddOrUpdateFile={this.props.onAddOrUpdateFile}
								   onFieldsChange={this.onFieldsChanged}/>
					<FormButtonsView align={"right"}>
						<ButtonTertiary onClick={this.props.onCancel}
										label={"Cancel"}
										disabled={this.props.isSubmitting}/>
						<ButtonPrimary onClick={() => this.submitForm()}
									   label={"Update asset"}
									   disabled={this.props.isSubmitting}
									   isLoading={this.props.isSubmitting}/>
					</FormButtonsView>
				</PageContentView>
			</Boxed>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit, () => {});
		});
	}
}
